let Toolbar: any = require('./toolbar');
let Preview: any = require('./preview');
let Administration: any = require('./administration');
let MaintenanceMode: any = require('./maintenanceMode');
let Search: any = require('./search/search');
let SearchKpi: any = require('./search/search.tracking');
let Help: any = require('./help/help');
let HelpLinks: any = require('./help/helpLinks');

import VCardEditor from 'diy/vcard/integration';
import features = require('diy/util/features');

export class App {
    private toolbar: any;
    private maintenanceMode: any;

    constructor(private vCardEditor: VCardEditor) {
    }

    getToolbar() {
        return this.toolbar;
    }

    getVCardEditor() {
        return this.vCardEditor;
    }

    init() {
        this.toolbar = new Toolbar();

        // TODO: separate rendering from construction
        let administration = new Administration(this.toolbar);
        let preview = new Preview(this.toolbar);
        this.maintenanceMode = new MaintenanceMode(this.vCardEditor, this.toolbar);
        let search = new Search(this.toolbar);

        Object.assign(this.toolbar, {
            Administration: administration,
            Preview: preview,
            MaintenanceMode: this.maintenanceMode,
            search: search,
            HelpLinks: HelpLinks
        });

        if (features('toolbarHelp')) {
            this.toolbar.help = new Help(this.toolbar);
        }

        //Init search tracking
        let searchKpi = new SearchKpi();
        searchKpi.init();

        //Init search angular app
        let searchModule: any = require('./search/search-module');
        searchModule.init(this.toolbar.search);
    }

    showPublishDialog() {
        this.maintenanceMode.show();
    }
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/toolbar/App.ts
 **/